/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useEffect, useState } from 'react';

import { localStorageService } from '../core';
import { type LocalStorageCacheKey } from '../config';

export const useValue = (key: LocalStorageCacheKey): string | undefined => {
  const [value, setValue] = useState(() => localStorageService.getValue(key));

  useEffect(() => {
    const callback = () => {
      setValue(localStorageService.getValue(key));
    };
    localStorageService.on('change', callback);
    return () => {
      localStorageService.off('change', callback);
    };
  }, [key]);
  return value;
};
